import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchBookings(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('appointment/event-bookings', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchBooking(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`appointment/event-bookings/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteBooking(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`appointment/event-bookings/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
